module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"productSearch":"Search by name","isManaged":"Filter by revenue management","isNew":"Filter by new","all":"All","yes":"Yes","no":"No"},"es":{"productSearch":"Buscar por nombre","isManaged":"Filtrar por gestión de ingresos","isNew":"Filtrar por nuevo","all":"Todos","yes":"Si","no":"No"}}')
  delete Component.options._Ctor
}
